export const LocalStorageKey = 'godata_tools_token';
